import React from "react";
import Link, { ILink } from "../../../Core/Link/Link";
import withDrawer, { IWithDrawerProps } from "../../../HOC/withDrawer";
import { footerLegalMentions } from "../../../Mocks/footer";
import FooterNews from "../../../Navigation/Footer/FooterWidget/FooterNews/FooterNews";
import LegalMention from "../../../Navigation/Footer/FooterWidget/LegalMention/LegalMention";
import Divider from "../../Divider/Divider";
import FlexBox from "../../FlexBox/FlexBox";
import { Container } from "../../Grid";

export interface IMenuContentProps extends IWithDrawerProps {
  links?: ILink[];
  secondaryLinks?: ILink[];
  socialLinks?: ILink[];
}

const MenuContent = (props: IMenuContentProps) => {
  const { links = [], secondaryLinks = [], socialLinks = [] } = props;
  return (
    <Container>
      <FlexBox
        direction="column"
        justify={"center"}
        style={{
          maxWidth: 386,
          margin: "0 auto",
          paddingTop: 36,
          paddingBottom: 36,
        }}
      >
        <FlexBox direction="column" gap={9}>
          {links.map((link, index) => {
            return (
              <Link key={index} variant="h4" color="champagne7" {...link} />
            );
          })}
        </FlexBox>

        <Divider weight={1} direction="horizontal" mt={32} mb={32} />

        <FlexBox direction="column" gap={74}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "auto auto",
              gap: 15,
            }}
          >
            {secondaryLinks.map((link, index) => {
              return (
                <div key={index}>
                  <Link
                    variant="body"
                    color="placeholder"
                    style={{ opacity: 0.7 }}
                    {...link}
                  />
                </div>
              );
            })}
          </div>

          <FooterNews
            mode="light"
            placeholder="Adresse e-mail"
            caption="En renseignant votre adresse e-mail, vous acceptez de recevoir des informations et offres marketing Sushi Shop par courrier électronique. Vous pouvez vous désabonner à tout moment à l'aide des liens de désinscription intégrés dans la newsletter."
          />

          <LegalMention
            links={footerLegalMentions}
            description="Politique de protection des données
          Exercez vos droits sur vos données
          Site by Wizzmedia"
          />

          <FlexBox gap={16}>
            {socialLinks.map((link, index) => {
              const { label, ...restL } = link;
              return (
                <Link
                  key={index}
                  variant="h4"
                  color="champagne7"
                  label=""
                  {...restL}
                />
              );
            })}
          </FlexBox>
        </FlexBox>
      </FlexBox>
    </Container>
  );
};

MenuContent.displayName = "MenuContent";

export const MenuContentDrawer = withDrawer<
  IMenuContentProps & IWithDrawerProps
>(MenuContent, {
  closable: true,
});

MenuContentDrawer.displayName = "MenuContentDrawer";

export default MenuContent;
